import src from "IMAGE";
export default { src, width: 495, height: 81, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ANLc7B7Cz+Uzu8raRLvK00q4yOFCtMTgRLrJ4kC/zeQ4ZOIVMwPrxXoAAAAASUVORK5CYII="};
